module.exports = __webpack_public_path__ + "media/icons/skrzynia-manualna-unactive@2x-042c4ba6.png";